import { z } from 'zod';
import { PLANS, ROLES } from '../constants.js';
import { WEEKDAYS, operatingHoursSchema } from '../booking.js';
import { nonEmptyTrimmed, uuidSchema } from './common.js';
export const slugSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/, 'Use lowercase letters, numbers and hyphens only.');
export const createWorkspaceSchema = z.object({
    name: nonEmptyTrimmed(80),
    slug: slugSchema,
});
export const updateWorkspaceSchema = z.object({
    name: nonEmptyTrimmed(80).optional(),
    settings: z.record(z.string(), z.unknown()).optional(),
    operatingHours: operatingHoursSchema.optional().superRefine((hours, ctx) => {
        if (!hours)
            return;
        for (const day of WEEKDAYS) {
            const value = hours[day];
            if (value && value.open >= value.close) {
                ctx.addIssue({ code: z.ZodIssueCode.custom, message: `${day}: open must be before close`, path: [day] });
            }
        }
    }),
});
export const deleteWorkspaceSchema = z.object({
    confirmName: z.string().min(1),
});
export const workspaceSummarySchema = z.object({
    workspaceId: uuidSchema,
    name: z.string(),
    slug: z.string(),
    role: z.enum(ROLES),
    plan: z.enum(PLANS),
    logoUrl: z.string().nullable(),
});
export const workspaceDetailSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    slug: z.string(),
    role: z.enum(ROLES),
    plan: z.enum(PLANS),
    trialEndsAt: z.string().nullable(),
    aiCreditsBalance: z.number().int(),
    stripeConnected: z.boolean(),
    stripeChargesEnabled: z.boolean(),
    logoUrl: z.string().nullable(),
    settings: z.record(z.string(), z.unknown()),
    seatCount: z.number().int(),
    multiLocationEnabled: z.boolean(),
    createdAt: z.string(),
    operatingHours: operatingHoursSchema,
});
export const localeSchema = z.enum(['en', 'zh-CN']);
export const meResponseSchema = z.object({
    userId: uuidSchema,
    email: z.string().nullable(),
    fullName: z.string(),
    phone: z.string().nullable(),
    locale: localeSchema,
    memberships: z.array(workspaceSummarySchema),
});
export const updateMeSchema = z.object({
    fullName: nonEmptyTrimmed(120).optional(),
    phone: z.string().trim().max(30).optional(),
    locale: localeSchema.optional(),
});
//# sourceMappingURL=workspace.js.map